<template>
  <div class="content">
    <el-form :model="propsParams" ref="ruleForm" label-width="100px" class="demo-ruleForm">
      <el-form-item label="公司名：" prop="companyName" label-width="130px">
				<el-input v-model="propsParams.companyName" style="width:260px" placeholder="公司名"></el-input>
      </el-form-item>
      <el-form-item label="对公账号：" prop="cardNumber" label-width="130px">
				<el-input v-model="propsParams.cardNumber" style="width:260px" placeholder="对公账号"></el-input>
      </el-form-item>
      <el-form-item label="开户行：" prop="openBank" label-width="130px">
				<el-input v-model="propsParams.openBank" style="width:260px" placeholder="开户行"></el-input>
      </el-form-item>
      <el-form-item label="银行资料：" prop="imgUrl" label-width="130px">
        <el-upload
            name="img"
            class="upload-demo"
            :action="url"
            :on-success="handleAvatarSuccess"
            :show-file-list="false"
            list-type="picture">
            <el-button size="small" type="primary">上传公司认证银行资料（盖公章）</el-button>
          </el-upload>
          <img class="reg-img" :src="home1" v-if="home1"/>
      </el-form-item>
      <p style="margin-bottom: 20px;"> 
        <el-button type="primary" class="buttonclass" @click="add" v-show="aa">添加下个银行信息</el-button>
      </p>
      <el-button type="primary" class="buttonclass" @click="handleSubmit">提交</el-button>
    </el-form>
  </div>
</template>
<script>
import { saveUserBank } from "@/api/api.js"; //信息提交
export default {
  data() {
    return {
      propsParams:{},
      home1:'',
      aa:true,
      url: process.env.VUE_APP_BASE_URL + process.env.VUE_APP_BASE_API + '/upload/uploadImage',
      gaibianurl: process.env.VUE_APP_BASE_URL + process.env.VUE_APP_BASE_API + '/upload/image/',
      arr:[]
    };
  },
  methods: {
    // 添加第二个银行信息
    add(){
      this.propsParams.imgUrl = this.home1;
      this.arr.push(this.propsParams);
      if(this.arr.length == 1){
        this.home1 = '';
        this.propsParams = {};
      }else if(this.arr.length > 2){
         this.$message.error('只允许添加两个银行信息');
         this.aa = false
      }
    },
    // 提交
    handleSubmit(){
      this.propsParams.imgUrl = this.home1;
      this.arr.push(this.propsParams);
      saveUserBank(this.arr).then(res =>{
        if (res.data.code == 200) {
          this.$notify({
            title: '成功',
            message: '添加银行卡认证成功',
            type: 'success'
          });
          this.$router.push("/scale/withdraw");
        }
      })
    },
    handleAvatarSuccess(res, file){
      this.home1 = this.gaibianurl + res.data;
    },
  },
  mounted() {

  },
  created() {

  }
};
</script>
<style scoped lang="less">
.buttonclass{
  margin-left: 130px;

}
.reg-img{
  width: 200px;
  height: 150px;
}
</style>


